import { DialogActions as MuiDialogActions, styled } from "@mui/material";
import clsx from "clsx";
import React from "react";
const classes = { footerRoot: "dialog-footer-root" };
const StyledMuiDialogActions = styled(MuiDialogActions)(({ theme }) => ({
    [`&.${classes.footerRoot}`]: {
        backgroundColor: theme.palette.controls.dialog.contentBackground,
        padding: "12px 30px 24px",
        "&.MuiDialogActions-spacing > :not(:first-child)": {
            marginLeft: "15px"
        }
    }
}));
export const DialogFooter = (props) => {
    return React.createElement(StyledMuiDialogActions, { ...props, className: clsx(classes.footerRoot, props.className), style: props.style });
};
